{
    "attributes": "Attribute",
    "properties": "Properties",
    "assignmentReturned": "assignment_returned",
    "refresh": "Refresh",
    "sync": "sync",
    "reset": "Reset",
    "search": "Search",
    "historyTab": "History Tab",
    "validateTab": "Validate Tab",
    "shortName": "Short Name",
    "format": "Format",
    "alphanumeric": "Alphanumeric",
    "boolean": "Boolean",
    "date": "Date",
    "number": "Number",
    "longName": "Long Name",
    "length": "Length",
    "description": "Description",
    "initialValue": "Initial Value",
    "defaultValue": "Default Value",
    "experianProtected": "Experian Protected",
    "delete": "Delete",
    "save": "Save",
    "areYouSure": "Are you sure?",
    "checkingAttributeDeletion": "Are you sure you would like to delete this attribute?",
    "checkingAttributesDeletion": "Would you like to delete the selected attributes?",
    "checkingAttributesDeletionInuse": "One or more entities are in use elsewhere. They will be deleted which may cause the system to become unstable.",
    "cancel": "Cancel",
    "ok": "Ok",
    "thanks": "Thanks!",
    "attributeDeleted": "The attribute was successfully deleted",
    "attributesDeleted": "The attributes were successfully deleted",
    "oops": "Oops!",
    "unknownError": "Unknown error returned from server, please try again",
    "checkingAttributeSave": "Are you sure you would like to save this attribute?",
    "attributeSaved": "The attribute was successfully saved",
    "emptyField": "Field cannot be empty",
    "systemName": "System Name",
    "overview": "Overview",
    "code": "Code",
    "validate": "Validate",
    "history": "History",
    "whereUsed": "Where Used",
    "attributesCopyTitle": "Copy Existing Attribute",
    "attributesCopyComment": "Please enter a new name for your attribute and select an attribute you would like to duplicate, then click copy",
    "attributesNotSelected": "Please select at least one record",
    "error": "Error",
    "newName": "New Name",
    "copyFrom": "Copy From",
    "create": "Create",
    "copy": "Copy",
    "attributesCreateTitle": "Create New Attribute",
    "attributesCreateComment": "Please choose a new name for your attribute and then click create",
    "attributesNameInvalid": "Attribute names must begin with a letter and may only contain letters, numbers and the underscore character",
    "attributesNameDuplicate": "An attribute or filter with this name already exists, please choose a different name",
    "saveTitle": "Are you sure?",
    "saveComment": "Are you sure you would like to save your changes to the server?",
    "discard": "Discard",
    "clickHere": "Click here to lock all",
    "systems": "Systems",
    "allAttributes": "All Attributes",
    "attributeName": "Attribute Name",
    "lastUpdated": "Last Updated",
    "version": "Version",
    "action": "Action",
    "editedBy": "Edited By",
    "comments": "Comments",
    "useThisVersion": "Use This Version",
    "currentVersion": "Current Version",
    "attribute": "Attribute",
    "yes": "Yes",
    "no": "No",
    "attributeRollbackCommit": "Do you want to roll back the code to a previous version?",
    "rollback": "Rollback",
    "successfulAttributeRollback": "Attribute has successfully been rolled back",
    "rollbackError": "Rollback Failed: ",
    "run": "Run",
    "selectDataSource": "Select Data Source",
    "dataSourceHistory": "Data Source",
    "dataFile": "Data File:",
    "additionalDataFile": "Data File {index}:",
    "dataFileFor": "{name} Data File:",
    "addDataFile": "Add Data File",
    "removeDataFile": "Remove Data File",
    "attributeOpenError": "Please close all open attribute tabs and try again.",
    "noDataSource": "No Datasource",
    "attributeServerSaveError": "Attribute with same name already exists",
    "reservedKeywordsError": "The short name entered is a reserved keyword and cannot be used",
    "deleteError": "One or more entities are currently open for editing by you and must be closed before they can be deleted",
	"attributeInUse": "Cannot delete an attribute currently in use by another attribute",
    "attributeLocked" : "Attribute succesfully locked",
    "attributeUnlocked" : "Attribute succesfully unlocked",
    "allAttributesLocked" : "All attributes succesfully locked",
    "allAttributesUnlocked" : "All attributes succesfully unlocked",
	"attributeAlertTitle": "Attributes",
    "fileUploadSizeError": "Invalid file size, allowed file size: 1 MB",
    "fileUploadExtensionError": "Invalid file extension, allowed file extensions: .txt, .xml, .dat"
}